import { useState } from "react";
import { Download, QrCode, ExternalLink } from "lucide-react";

export const QRGenerator = ({ restaurant }) => {
  const count = restaurant.table_count || 8;
  const tables = Array.from({ length: count }, (_, i) => i + 1);
  const [selected, setSelected] = useState(1);

  const menuUrl = (table) => `${window.location.origin}/menu/${restaurant.id}?table=${table}`;
  const qrSrc = (table, size = 300) => `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=10&data=${encodeURIComponent(menuUrl(table))}`;

  const download = (table) => {
    const a = document.createElement("a");
    a.href = qrSrc(table, 600);
    a.download = `${restaurant.name}-table-${table}.png`;
    a.target = "_blank";
    a.click();
  };

  return (
    <div>
      <h2 className="font-heading text-2xl font-bold mb-1">Table QR codes</h2>
      <p className="text-slate-400 text-sm mb-6">Print one for each table. Guests scan to open your menu.</p>

      <div className="grid lg:grid-cols-[1fr_320px] gap-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {tables.map((t) => (
            <button
              key={t}
              data-testid={`qr-table-${t}`}
              onClick={() => setSelected(t)}
              className={`bg-slate-900 border rounded-2xl p-4 flex flex-col items-center gap-2 transition-all ${selected === t ? "border-orange-500 ring-1 ring-orange-500" : "border-slate-800 hover:border-slate-600"}`}
            >
              <img src={qrSrc(t, 150)} alt={`Table ${t} QR`} className="w-full rounded-lg bg-white p-1" />
              <span className="font-sub font-semibold text-sm">Table {t}</span>
            </button>
          ))}
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 h-fit sticky top-6">
          <div className="flex items-center gap-2 text-slate-400 text-sm mb-4">
            <QrCode className="h-4 w-4" /> Table {selected} preview
          </div>
          <div className="bg-white rounded-xl p-4 text-center">
            <p className="font-heading text-lg font-bold text-slate-900">{restaurant.name}</p>
            <img src={qrSrc(selected, 300)} alt="QR" className="w-full mt-2" />
            <p className="font-mono-j text-xs text-slate-500 mt-2">TABLE {selected} · SCAN TO ORDER</p>
          </div>
          <button data-testid="download-qr-button" onClick={() => download(selected)} className="w-full mt-4 inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 rounded-xl py-3 font-semibold transition-colors">
            <Download className="h-4 w-4" /> Download PNG
          </button>
          <a data-testid="preview-menu-link" href={menuUrl(selected)} target="_blank" rel="noreferrer" className="w-full mt-2 inline-flex items-center justify-center gap-2 border border-slate-700 hover:border-slate-500 rounded-xl py-2.5 text-sm font-medium transition-colors">
            <ExternalLink className="h-4 w-4" /> Open customer menu
          </a>
        </div>
      </div>
    </div>
  );
};
